// Workspace layout created by tools/gen_web_routes.py; owned by hand from here on.
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { rememberOrg } from '../../../shared/org/lastOrg'
import { membershipBySlug, meQuery } from '../../../shared/org/me'
import { AppShell } from '../../../shared/shell/AppShell'

export const Route = createFileRoute('/o/$orgSlug')({
  // The slug resolves to a membership from /me; an organization the person is not in renders NotFound, never
  // "forbidden", so ids cannot be probed (D28, spec 08 § 5). The sign-in redirect stays with the session guard.
  beforeLoad: async ({ context: { queryClient }, params: { orgSlug } }) => {
    const me = await queryClient.ensureQueryData(meQuery())
    const membership = membershipBySlug(me, orgSlug)
    if (!membership) throw notFound()
    rememberOrg(orgSlug)
    return { membership }
  },
  staticData: { workspace: 'org' },
  component: OrgLayout,
})

function OrgLayout() {
  // A demo organization's chip is the shell's, in the top bar (D219): no bar above the content.
  return (
    <AppShell workspace="org">
      <Outlet />
    </AppShell>
  )
}
